import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const updateContractCooperationType = ({
  payload,
  cooperationTypeId,
}: {
  payload: TPaymentModel | TEditedData;
  cooperationTypeId: number;
}) => API.put(`/api/cooperation-types/${cooperationTypeId}`, payload);
